module.exports = __webpack_public_path__ + "img/vote_illustration4.966918d4.png";